import { http } from '../../config/axios'

export default function postServico(servico: any): Promise<string> {
  return http
    .post('api/servico', servico)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post servico', error)
      throw Error(error.response.data)
    })
}
